import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import AuthService from "services/auth.service";

const Check = ({ children }) => {
  const { user, isLoggedIn } = useAuth();
  
  useEffect(() => {
    // Check if token is expired on component mount
    if (user) {
      AuthService.logoutIfExpired();
    }
  }, [user]);
  
  // If no user or token is expired, redirect to login
  if (!isLoggedIn || AuthService.isTokenExpired()) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default Check;
